import React from "react";

import { connect } from "react-redux";
import './Footer.css';

class Footer extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }


	

    componentDidMount(){


       
	}
	componentWillUnmount(){
    }


	

  

    

    render(){

    return(


<div class="footer-txt">Copyright &copy; 2022 All rights reserved. <br/>Powered by Uvva Infotech Pvt. Ltd.</div>

);
} 
}

const mapStateToProps = (
{ errorMessageReduce:{errorMessage,loginErrorMessage},
miscReduce:{phone}}
) => ({
  errorMessage,loginErrorMessage,phone
});

export default connect(mapStateToProps, null)(Footer);
